// extracted by mini-css-extract-plugin
export default {"label":"Select_label__hCWhq","select":"Select_select__OWo2B"};